/**
 * 图片模型 manifest 聚合
 *
 * 接入新图片模型：在 ./<模型>.ts 新增配置文件 → 加入下方数组即可（registry 无需改动）。
 */
import type { ImageModelConfig } from '../../types';
import { hailuo01 } from './hailuo-01';
import { jimeng4_0 } from './jimeng-4-0';
import { nanoBanana } from './nano-banana';
import { mjYouchuanV7 } from './mj-youchuan-v7';
import { nanoBananaPro } from './nano-banana-pro';
import { jimeng4_5 } from './jimeng-4-5';
import { nanoBanana2 } from './nano-banana-2';
import { jimeng5Lite } from './jimeng-5-lite';
import { kling3Omni } from './kling-3-omni';
import { gptImage2 } from './gpt-image-2';
import { mjYouchuanV8 } from './mj-youchuan-v8';
import { gptImage2_5Flare } from './gpt-image-2.5-flare';
import { gptImage2_5Sunburst } from './gpt-image-2.5-sunburst';
import { kling1_5 } from './kling-v1-5';
import { kling2_0 } from './kling-v2';
import { jimeng2_1 } from './jimeng-v2-1';
import { jimeng3_0 } from './jimeng-v3-0';

/** 全部图片模型 manifest（顺序不影响查询，仅便于阅读） */
export const IMAGE_MODEL_CONFIGS: ImageModelConfig[] = [
  mjYouchuanV7,
  mjYouchuanV8,
  nanoBanana,
  nanoBananaPro,
  nanoBanana2,
  hailuo01,
  kling3Omni,
  jimeng4_0,
  jimeng4_5,
  jimeng5Lite,
  gptImage2,
  gptImage2_5Flare,
  gptImage2_5Sunburst,
  // 旧模型（接口 disable: true），补全 manifest 以收敛历史硬编码
  kling1_5,
  kling2_0,
  jimeng2_1,
  jimeng3_0,
];
